webpackJsonp([18],{

/***/ 495:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_http_axios__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_format__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_v_money__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_v_money___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_v_money__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var moment = __webpack_require__(315);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "FormCadpromocao",
  props: ["dialog", "dados", "zeraCampos"],
  mixins: [__WEBPACK_IMPORTED_MODULE_2__services_format__["a" /* formata */]],
  directives: { money: __WEBPACK_IMPORTED_MODULE_3_v_money__["VMoney"] },
  data: function data() {
    return {
      diasSemana: [{ dia_semana: 0, dia: "Todos" }, { dia_semana: 1, dia: "Domingo" }, { dia_semana: 2, dia: "Segunda-Feira" }, { dia_semana: 3, dia: "Terça-Feira" }, { dia_semana: 4, dia: "Quarta-Feira" }, { dia_semana: 5, dia: "Quinta-Feira" }, { dia_semana: 6, dia: "Sexta-Feira" }, { dia_semana: 7, dia: "Sábado" }],
      money: {
        decimal: ".",
        thousands: " ",
        prefix: "",
        suffix: "",
        precision: 2,
        masked: true /* doesn't work with directive */
      },
      promocao: {
        cod_produto: "",
        desconto: "",
        validade: "",
        dia_semana: "",
        id: ""
      },
      menu: "",
      dataFim: moment().format("YYYY-MM-DD"),
      dataFimFormatted: moment().format("DD/MM/YYYY"),
      alterar: "",
      cnpjRules: [function (v) {
        return !!v || "Cnpj é requerido";
      }, function (v) {
        return v.length == 14 || "Cnpj   Menor que o padrão";
      }]
    };
  },
  mounted: function mounted() {
    //  alert("ativou");
    //this.$refs.cod_produto.focus();
    //this.$refs.cod_produto.select();
  },

  computed: {
    computedDateFormatted: function computedDateFormatted() {
      return this.formatDate(this.dataIn);
    }
  },

  watch: {
    zeraCampos: function zeraCampos(val) {
      if (val == "novo") {
        this.promocao.cod_produto = "";
        this.promocao.desconto = "";
        this.promocao.dia_semana = "";
        this.dataFim = moment().format("YYYY-MM-DD"), this.dataFimFormatted = moment().format("DD/MM/YYYY");
      }
      // alert("alterou");

      // this.dataFim = this.parseDate(val.validade);
    },
    dados: function dados(val) {
      var _this = this;

      if (val) {
        this.promocao.cod_produto = val.cod_produto;

        this.promocao.validade = val.validade;
        this.dataFim = this.parseDate(val.validade);
        this.promocao.id = val.id;
        this.promocao.dia_semana = val.dia_semana;
        this.alterar = "Alterar ";
        setTimeout(function () {
          // alert(val.desconto);
          _this.promocao.desconto = val.desconto;
        }, 1000);
      } else {
        this.promocao.id = "";
        this.alterar = "";
      }
    },
    dataIn: function dataIn(val) {
      this.dataInFormatted = this.formatDate(this.dataIn);
    },
    dataFim: function dataFim(val) {
      this.dataFimFormatted = this.formatDate(this.dataFim);
      this.promocao.validade = this.parseDate(this.dataFimFormatted);
    }
  },

  methods: {
    atualizar: function atualizar() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1__services_http_axios__["a" /* HTTP */].put("promocao/" + this.promocao.id, this.promocao).then(function (response) {
        _this2.promocao.id = "";

        _this2.$emit("gravacaoOkpromocao");
        _this2.$emit("fechaDialog");
        _this2.$emit("MensagemGravaSucesso", "Gravação executado com sucesso!");

        _this2.zeraCampos("novo");
      }).catch(function (e) {
        // console.log("erros:::::" + e.response.data.errors);
        if (e.response != undefined) {
          if (!Array.isArray(e.response.data.error)) {
            var itens = [];
            for (var prop in e.response.data.error) {
              itens.push(e.response.data.error[prop][0]);
            }

            _this2.$emit("getCadpromocao", itens.join(","));
          }
        }
      });
      // this.$parent.selDialog = false;
    },
    salvar: function salvar() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_1__services_http_axios__["a" /* HTTP */].post("promocao", this.promocao).then(function (response) {
        if (response.data.error) {
          alert("erross:");
        }
        _this3.promocao.cod_produto = "";
        _this3.promocao.desconto = "";
        _this3.promocao.validade = "";
        _this3.$emit("gravacaoOkpromocao");
        _this3.$emit("fechaDialog");
        _this3.$emit("MensagemGravaSucesso", "Gravação executado com sucesso!");
      }).catch(function (e) {
        // console.log("erros:::::" + e.response.data.errors);
        console.log(e.response.data.error);
        if (!Array.isArray(e.response.data.error)) {
          var itens = [];
          for (var prop in e.response.data.error) {
            itens.push(e.response.data.error[prop][0]);
          }

          _this3.$emit("getCadpromocao", itens.join(","));
        }
      });
      // this.$parent.selDialog = false;
    },
    parente: function parente() {
      this.$emit("fechaDialog");
    },
    checkStatus: function checkStatus(valor) {
      if (valor) {
        return "Ativo";
      } else {
        return "Inativo ";
      }
    },
    filtrar: function filtrar() {
      this.buscaExtratoCartao(this.dataIn, this.dataFim);
    },
    formata_moeda: function formata_moeda(val) {
      var val1 = val / 100;
      var valor = this.formatar_moeda(val1);
      return valor;
    },
    buscapromocaos: function buscapromocaos() {
      var _this4 = this;

      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_1__services_http_axios__["a" /* HTTP */].get("grupo/lista/promocao").then(function (response) {
        if (response.data.error) {
          _this4.textSnack = response.data.error;
          _this4.snackbar = true;
        } else {
          //this.extrato =

          _this4.items = response.data;
          _this4.mostraCartoes = true;
        }
        _this4.loading = false;
      });
    },


    //mudar para um mixed
    formatDate: function formatDate(date) {
      if (!date) return null;

      var _date$split = date.split("-"),
          _date$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_date$split, 3),
          year = _date$split2[0],
          month = _date$split2[1],
          day = _date$split2[2];

      return day + "/" + month + "/" + year;
    },
    parseDate: function parseDate(date) {
      if (!date) return null;

      var _date$split3 = date.split("/"),
          _date$split4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_date$split3, 3),
          day = _date$split4[0],
          month = _date$split4[1],
          year = _date$split4[2];

      return year + "-" + month.padStart(2, "0") + "-" + day.padStart(2, "0");
    }
  }
});

/***/ }),

/***/ 528:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormCadPromocao_vue__ = __webpack_require__(495);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f209f1a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormCadPromocao_vue__ = __webpack_require__(531);
function injectStyle (ssrContext) {
  __webpack_require__(529)
}
var normalizeComponent = __webpack_require__(103)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormCadPromocao_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f209f1a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormCadPromocao_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 529:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(530);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(299)("74d3f046", content, true, {});

/***/ }),

/***/ 530:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(298)(true);
// imports


// module
exports.push([module.i, "#container{margin-top:115px}", "", {"version":3,"sources":["C:/Users/chris/projetos/GrupoPrepago/src/components/FormCadPromocao.vue"],"names":[],"mappings":"AACA,WACE,gBAAkB,CACnB","file":"FormCadPromocao.vue","sourcesContent":["\n#container {\r\n  margin-top: 115px;\n}\r\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 531:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"persistent":"","max-width":"800px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.alterar)+" Promoção")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-text-field',{ref:"cod_produto",attrs:{"box":"","mask":"#######","autofocus":"","label":"Código Produto","required":""},model:{value:(_vm.promocao.cod_produto),callback:function ($$v) {_vm.$set(_vm.promocao, "cod_produto", $$v)},expression:"promocao.cod_produto"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-text-field',{ref:"desconto",attrs:{"box":"","label":"% Desconto","hint":"Utilize ponto e números ex:0.00 ","required":""},model:{value:(_vm.promocao.desconto),callback:function ($$v) {_vm.$set(_vm.promocao, "desconto", $$v)},expression:"promocao.desconto"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"s12":"","sm6":""}},[_c('v-select',{attrs:{"items":_vm.diasSemana,"item-text":"dia","item-value":"dia_semana","label":"Dia da Semana","single-line":""},model:{value:(_vm.promocao.dia_semana),callback:function ($$v) {_vm.$set(_vm.promocao, "dia_semana", $$v)},expression:"promocao.dia_semana"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-menu',{ref:"menu",attrs:{"close-on-content-click":false,"nudge-right":170,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_c('v-text-field',{attrs:{"slot":"activator","outline":"","label":"Validade","readonly":"","persistent-hint":"","prepend-icon":"event","required":""},on:{"blur":function($event){_vm.promocao.validade = _vm.parseDate(_vm.dataFimFormatted)}},slot:"activator",model:{value:(_vm.dataFimFormatted),callback:function ($$v) {_vm.dataFimFormatted=$$v},expression:"dataFimFormatted"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"locale":"pt-br","no-title":""},on:{"input":function($event){_vm.menu = false}},model:{value:(_vm.dataFim),callback:function ($$v) {_vm.dataFim=$$v},expression:"dataFim"}})],1)],1)],1)],1),_vm._v(" "),_c('small',[_vm._v("*Campos requeridos")])],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"color":"terciary"},nativeOn:{"click":function($event){_vm.parente()}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"color":"sucesso"},nativeOn:{"click":function($event){_vm.promocao.id==''? _vm.salvar():_vm.atualizar()}}},[_vm._v("Gravar")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/18.29250f2a46293ae4c52a.js